
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 19 19","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.5 17.417a7.71 7.71 0 01-3.088-.624A7.994 7.994 0 013.9 15.101a7.995 7.995 0 01-1.692-2.513A7.71 7.71 0 011.583 9.5c0-1.095.208-2.124.624-3.087a7.995 7.995 0 011.692-2.514 7.995 7.995 0 012.513-1.692A7.709 7.709 0 019.5 1.584a7.71 7.71 0 013.088.623c.963.416 1.8.98 2.513 1.692a7.994 7.994 0 011.692 2.514c.416.963.624 1.992.624 3.087a7.708 7.708 0 01-.624 3.088 7.994 7.994 0 01-1.692 2.513 7.994 7.994 0 01-2.514 1.692 7.71 7.71 0 01-3.087.624z"}})])
          )
        }
      }
    